import {z} from 'zod';

export interface IntegratedService {
  integration_id: string;
  code?: string;
}

export type GetIntegratedServicesApiResponse = IntegratedService[];

export type GetIntegratedServicesApiArg = void;

export type GetSelectableMaterialsIntegrationsApiResponse = [
  {
    integrationId: string;
    name: string;
    code: string;
    description?: string | null;
  },
];

export type GetSelectableMaterialsIntegrationsApiArg = void;

// GET /admin/v1/tenant/{tenantId}/integrations
export const TenantIntegrationSchema = z.object({
  integrationId: z.string(),
  name: z.string(),
  code: z.string(),
  description: z.string().nullable().optional(),
  authorizationProfileIds: z.array(z.string()),
});

export const GetTenantIntegrationsAdvancedSearchApiResponseSchema =
  z.array(TenantIntegrationSchema);
export type GetTenantIntegrationsAdvancedSearchApiResponse = z.infer<
  typeof GetTenantIntegrationsAdvancedSearchApiResponseSchema
>;

export const GetTenantIntegrationsAdvancedSearchApiArgSchema = z.object({
  tenantId: z.string(),
  branchId: z.array(z.string()).optional(),
  authorizationProfileId: z.array(z.string()).optional(),
  authorizationId: z.array(z.string()).optional(),
  integrationCode: z.array(z.string()).optional(),
});
export type GetTenantIntegrationsAdvancedSearchApiArg = z.infer<
  typeof GetTenantIntegrationsAdvancedSearchApiArgSchema
>;
